<template>
  <el-dialog
    :title="model.id ? '编辑对照' : '新增对照'"
    :visible.sync="visible"
    width="800px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="商品 PH" prop="ph">
        <el-autocomplete
          style="width: 100%"
          v-model="model.ph"
          :fetch-suggestions="queryPHSearch"
          placeholder="请选择或输入PH"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="设备分类" prop="item_category_ids">
        <MultiItemCategorySelect
          v-if="visible"
          v-model="model.item_category_ids"
          :category="2"
        ></MultiItemCategorySelect>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createCommodityPh, updateCommodityPh } from '@/service/getData'
import MultiItemCategorySelect from '@/views/wikis/MultiItemCategorySelect'
import { CommodityPhs } from '@/config/global.js'

export default {
  components: {
    MultiItemCategorySelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        ph: [{ required: true, message: '请填写PH值', trigger: 'change' }],
        item_category_ids: [
          { required: true, message: '请选择设备分类', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateCommodityPh(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createCommodityPh(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('created', res.data)
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    queryPHSearch(queryString, cb) {
      var restaurants = CommodityPhs
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > 0
        )
      }
    },
  },
}
</script>

<style scoped>
/deep/.ql-editor {
  min-height: 200px;
}

/deep/.ql-formats {
  line-height: 0;
}
</style>